"use strict";
import React from "react";
import _ from "underscore";
import Account from "../../api/account";
import CarrierName from "../carrier_name";
import DisablingButton from "../../components/disabling_button";
import generalFormatter from "../../formatters/general";
import { isFactorAccount } from "../../helpers/app";
import uuid from "@lukeed/uuid";
import { isLtlReconcileEnabled } from "../ltl/reconcile";
import LtlHeader from "../ltl/indexer_header";
import { boxIcon, truckIcon } from "../ui/header_icons";
import { arrowDown, arrowUp, copyIcon, warningIcon } from "../ui/icons";
import { Button, ButtonSize, ButtonVariant } from "../ui/v3/button";
import { Tooltip, TooltipDirection, TooltipLocation } from "../ui/v3/tooltip";
import { StatusTag, StatusTagStyle, StatusTagSize } from "../ui/v3/status_tag";
import * as popout from "./../popout";
import {
  CustomerMarginHeader,
  CustomerMarginHeaderTooltipPlacement
} from "./customer_margin_header";
function carrierNamePrefix() {
  return /* @__PURE__ */ React.createElement(
    "span",
    {
      className: "indexer-header__carrier-label",
      "data-tooltip": true,
      "aria-haspopup": "true",
      title: "The " + Account.carrierTerm() + " associated with this email address"
    },
    "Email ",
    Account.carrierTerm(),
    ":\xA0"
  );
}
function button(title, callback, index, icon = "") {
  if (icon) {
    const iconClasses = "icon icon-" + icon + " icon--no-repeat icon--sm ml-2";
    return /* @__PURE__ */ React.createElement(
      "button",
      {
        className: "v3__button-outlined indexer-header__view-email",
        onClick: callback,
        key: "action-button-" + index
      },
      title,
      /* @__PURE__ */ React.createElement("span", { className: iconClasses })
    );
  } else {
    return /* @__PURE__ */ React.createElement(
      "button",
      {
        className: "v3__button-outlined indexer-header__view-email",
        onClick: callback,
        key: "action-button-" + index
      },
      title
    );
  }
}
function openBillingReqsPopout(customerId) {
  popout.setCustomerId(customerId);
  popout.openOrFocusBillingReqsPopout();
}
function openLoadLink(event) {
  if (event.target.value) {
    window.open(event.target.value, "_blank");
  }
  event.target.value = "";
}
function maybeStatePill(state) {
  return state && /* @__PURE__ */ React.createElement("div", { className: "indexer-header__customer-state" }, state);
}
function maybeStatePillV3Reskin(state) {
  return state && /* @__PURE__ */ React.createElement("span", { style: { marginLeft: "4px" } }, /* @__PURE__ */ React.createElement(
    StatusTag,
    {
      content: state,
      style: StatusTagStyle.Info,
      size: StatusTagSize.Small
    }
  ));
}
function showCustomerStatuses() {
  return Account.auditBillingEnabled();
}
export default React.createClass({
  // eslint-disable-line no-restricted-syntax -- Legacy React.createClass - to be migrated
  getInitialState: function() {
    return {
      copyTooltipText: "Copy",
      linksOpen: false
    };
  },
  renderDefault: function() {
    const email = this.props.email || {};
    let subject = email.subject || "Uploaded Document";
    let subtitle = email.sender_address;
    if (this.props.displayReference && this.props.load) {
      const referenceLabel = Account.currentSettings().load_display_reference_label;
      const referenceKey = Account.currentSettings().load_display_reference_key;
      const referenceValue = this.props.load.references[referenceKey];
      if (referenceValue) {
        subject = `${referenceLabel} ${referenceValue}`;
        subtitle = `Load ${this.props.load.load_id}`;
      }
    }
    return /* @__PURE__ */ React.createElement("div", { className: "indexer-header__container" }, /* @__PURE__ */ React.createElement("div", { className: "indexer-header__subject-area" }, /* @__PURE__ */ React.createElement("div", { className: "indexer-header__subject" }, subject), /* @__PURE__ */ React.createElement("div", { className: "indexer-header__subtitle" }, subtitle), this.displayCustomerMargin() && this.renderDateTime()), /* @__PURE__ */ React.createElement("div", { className: "indexer-header__action-area" }, /* @__PURE__ */ React.createElement("div", { className: "indexer-header__date-area" }, !this.displayCustomerMargin() && this.renderDateTime(), /* @__PURE__ */ React.createElement("div", { className: "indexer-header__customer_carrier-area" }, this.renderCustomerNames(), this.carrier()), this.displayCustomerMargin() && /* @__PURE__ */ React.createElement(
      CustomerMarginHeader,
      {
        invoice: this.props.invoice,
        tooltipPlacement: CustomerMarginHeaderTooltipPlacement.After,
        useV3Typography: false,
        labelValueSeparator: ":"
      }
    )), /* @__PURE__ */ React.createElement("div", { className: "indexer-header__center-action-area" }), /* @__PURE__ */ React.createElement("div", { className: "indexer-header__right-action-area" }, this.markCompleteButton(), this.ignoreEntryButton(), this.actions(), this.loadLinks())));
  },
  renderLtl: function(displayProNumber) {
    let referenceLabel = null, referenceValue = null;
    if (this.props.displayReference && this.props.load) {
      referenceLabel = Account.currentSettings().load_display_reference_label;
      const referenceKey = Account.currentSettings().load_display_reference_key;
      referenceValue = this.props.load.references[referenceKey];
    }
    return /* @__PURE__ */ React.createElement("div", { className: "indexer-header__action-area-ltl" }, /* @__PURE__ */ React.createElement(
      LtlHeader,
      {
        displayProNumber,
        email: this.props.email,
        invoice: this.props.invoice,
        load: this.props.load,
        location: this.props.location,
        referenceLabel,
        referenceValue
      }
    ), /* @__PURE__ */ React.createElement("div", { className: "indexer-header__right-action-area-ltl indexer-header__right-action-area" }, this.markCompleteButton(), this.ignoreEntryButton(), this.actions(), this.loadLinks()));
  },
  renderV3Reskin: function() {
    const displayProNumber = this.props.invoice && isLtlReconcileEnabled(this.props.invoice);
    let reference;
    if (this.props.displayReference && this.props.load) {
      const referenceLabel = Account.currentSettings().load_display_reference_label;
      const referenceKey = Account.currentSettings().load_display_reference_key;
      const referenceValue = this.props.load.references[referenceKey];
      if (referenceValue) {
        reference = /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: "var(--space-xxxs)" } }, /* @__PURE__ */ React.createElement("span", { className: "v3__type__small-body-semi-bold" }, referenceLabel), /* @__PURE__ */ React.createElement("span", null, referenceValue));
      }
    }
    const topLeftColumn = /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexFlow: "column", gap: "6px" } }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("span", { style: { color: "var(--color-grayscale-600)" } }, boxIcon()), /* @__PURE__ */ React.createElement(
      "span",
      {
        className: "v3__type__small-body-semi-bold",
        style: { margin: "0 4px" }
      },
      "Customer"
    ), /* @__PURE__ */ React.createElement("span", null, this.renderCustomerNamesV3Reskin())), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("span", { style: { color: "var(--color-grayscale-600)" } }, truckIcon()), /* @__PURE__ */ React.createElement(
      "span",
      {
        className: "v3__type__small-body-semi-bold",
        style: { margin: "0 4px" }
      },
      "Carrier"
    ), /* @__PURE__ */ React.createElement(
      CarrierName,
      {
        carrierID: this.props.email.carrier_id,
        multiple: this.props.email.single_carrier === false,
        displayAccountExec: false,
        displayNoBuy: false,
        carrierNameSuffix: "",
        carrierNamePrefix: "",
        v3ReskinEnabled: this.props.v3ReskinEnabled,
        carrierInvoices: this.props.carrierInvoices,
        trailingChip: maybeStatePillV3Reskin(
          this.props.invoice && this.props.invoice.status
        )
      }
    )));
    const bottomLeftColumn = /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexFlow: "column", gap: "6px" } }, /* @__PURE__ */ React.createElement(
      "div",
      {
        style: {
          display: "flex",
          alignItems: "center",
          gap: "var(--space-xxxs)"
        }
      },
      /* @__PURE__ */ React.createElement("span", { className: "v3__type__small-body-semi-bold" }, "Load"),
      /* @__PURE__ */ React.createElement("span", null, this.props.load.load_id),
      /* @__PURE__ */ React.createElement(
        Tooltip,
        {
          content: /* @__PURE__ */ React.createElement("span", { className: "copy-icon", onClick: this.copyLoadId }, copyIcon()),
          tooltipContent: this.state.copyTooltipText,
          direction: TooltipDirection.Right,
          location: TooltipLocation.Hidden,
          onClick: this.copyLoadId
        }
      )
    ), displayProNumber && /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: "var(--space-xxxs)" } }, /* @__PURE__ */ React.createElement("span", { className: "v3__type__small-body-semi-bold" }, "Pro number"), /* @__PURE__ */ React.createElement("span", null, this.props.load.pro_number)), reference);
    const buttons = _.map(this.props.actions, function(action, index) {
      const title = action[0];
      const callback = action[1];
      return /* @__PURE__ */ React.createElement(
        Button,
        {
          size: ButtonSize.Medium,
          variant: ButtonVariant.Outlined,
          onClick: callback,
          key: "action-button-" + index
        },
        title
      );
    });
    const topRightColumn = /* @__PURE__ */ React.createElement(
      "div",
      {
        style: {
          display: "flex",
          flexFlow: "column",
          justifyContent: "space-between",
          alignItems: "end",
          gap: "var(--space-xxs)"
        }
      },
      /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: "var(--space-xxs)" } }, buttons)
    );
    const bottomRightColumn = /* @__PURE__ */ React.createElement(
      "div",
      {
        style: { display: "flex", gap: "var(--space-xxs)", alignItems: "end" }
      },
      this.customerDetails(),
      this.loadLinksV3Reskin()
    );
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        style: {
          display: "flex",
          flexFlow: "column",
          gap: "var(--space-xxs)"
        }
      },
      /* @__PURE__ */ React.createElement(
        "div",
        {
          style: {
            display: "flex",
            justifyContent: "space-between",
            gap: "var(--space-xxs)"
          }
        },
        topLeftColumn,
        topRightColumn
      ),
      /* @__PURE__ */ React.createElement(
        "div",
        {
          style: {
            display: "flex",
            justifyContent: "space-between",
            gap: "var(--space-xxs)"
          }
        },
        bottomLeftColumn,
        bottomRightColumn
      )
    );
  },
  copyLoadId: function() {
    navigator.clipboard.writeText(this.props.load.load_id);
    this.setState({ copyTooltipText: "Copied" });
    setTimeout(() => {
      this.setState({ copyTooltipText: "Copy" });
    }, 1e3);
  },
  render: function() {
    if (this.props.v3ReskinEnabled) {
      return this.renderV3Reskin();
    } else if (this.props.isLtlAuditCustomer) {
      const displayProNumber = this.props.invoice && isLtlReconcileEnabled(this.props.invoice);
      return this.renderLtl(displayProNumber);
    } else {
      return this.renderDefault();
    }
  },
  actions: function() {
    return _.map(this.props.actions, (action, index) => {
      return button(action[0], action[1], index, action[2]);
    });
  },
  markCompleteButton: function() {
    if (this.props.canMarkComplete) {
      return /* @__PURE__ */ React.createElement(
        DisablingButton,
        {
          className: "v3__button-tertiary indexer-header__ignore-link",
          disabledText: "Ignoring...",
          disabled: this.state.completing,
          onClick: this.props.markComplete
        },
        "Ignore This Entry"
      );
    }
  },
  ignoreEntryButton: function() {
    if (this.props.canIgnoreEntry) {
      if (this.state.ignoring) {
        return /* @__PURE__ */ React.createElement(
          "button",
          {
            className: "v3__button-tertiary indexer-header__ignore-link",
            disabled: true
          },
          "Ignoring..."
        );
      } else {
        return /* @__PURE__ */ React.createElement(
          "button",
          {
            className: "v3__button-tertiary indexer-header__ignore-link",
            onClick: this.ignoreEntry
          },
          "Ignore All Groups"
        );
      }
    }
  },
  loadLinks: function() {
    const links = this.props.load && this.props.load.data && this.props.load.data.links || [];
    if (links.length === 0) {
      return null;
    }
    const selectOptions = links.map((x, i) => /* @__PURE__ */ React.createElement("option", { key: i, value: x.url }, x.text));
    return /* @__PURE__ */ React.createElement(
      "select",
      {
        value: void 0,
        onChange: openLoadLink,
        className: "indexer-header__load-links"
      },
      /* @__PURE__ */ React.createElement("option", { value: "" }, "Links to TMS"),
      selectOptions
    );
  },
  customerDetails: function() {
    if (!(Account.useBillingReqsPopout() && Account.hasRole("Broker"))) {
      return null;
    }
    const load = this.props.load;
    const loadShipments = (load == null ? void 0 : load.tms_load_shipments) || [];
    const loadShipment = loadShipments[0];
    const customerId = loadShipment == null ? void 0 : loadShipment.customer_id;
    const showAlertIcon = loadShipments == null ? void 0 : loadShipments.some(
      (shipment) => shipment.customer_instructions && shipment.customer_instructions.length > 0
    );
    const alertIcon = /* @__PURE__ */ React.createElement(
      Tooltip,
      {
        content: /* @__PURE__ */ React.createElement(
          "span",
          {
            style: {
              position: "relative",
              top: "2px"
            }
          },
          warningIcon()
        ),
        tooltipContent: "Customer instructions are present",
        direction: TooltipDirection.Left,
        location: TooltipLocation.Hidden
      }
    );
    return /* @__PURE__ */ React.createElement(
      Button,
      {
        size: ButtonSize.Medium,
        variant: ButtonVariant.Text,
        onClick: () => openBillingReqsPopout(customerId)
      },
      showAlertIcon && alertIcon,
      "Customer details"
    );
  },
  loadLinksV3Reskin: function() {
    const links = this.props.load && this.props.load.data && this.props.load.data.links || [];
    if (links.length === 0) {
      return null;
    }
    const openDropdown = () => {
      this.setState({ linksOpen: true });
    };
    const closeDropdown = () => {
      this.setState({ linksOpen: false });
    };
    const openLink = (url) => {
      window.open(url, "_blank");
      this.setState({ linksOpen: false });
    };
    const linksList = /* @__PURE__ */ React.createElement("div", { style: { position: "relative" } }, /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "v3-tertiary-dropdown__scrim",
        onClick: closeDropdown
      }
    ), /* @__PURE__ */ React.createElement("div", { className: "v3-tertiary-dropdown__list" }, links.map((x, i) => /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "v3-tertiary-dropdown__item",
        key: i,
        onClick: () => openLink(x.url)
      },
      x.text
    ))));
    return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
      Button,
      {
        size: ButtonSize.Medium,
        variant: ButtonVariant.Text,
        onClick: openDropdown
      },
      "View in TMS ",
      this.state.linksOpen ? arrowUp() : arrowDown()
    ), this.state.linksOpen && linksList);
  },
  ignoreEntry: function() {
    this.props.ignoreEntry();
  },
  setCarrierLink: function() {
    if (this.props.canSetCarrier) {
      return /* @__PURE__ */ React.createElement(
        "a",
        {
          className: "indexer-header__set-carrier-link",
          onClick: this.props.setCarrier
        },
        /* @__PURE__ */ React.createElement("span", null, "\xA0"),
        /* @__PURE__ */ React.createElement("i", { className: "fi-pencil" })
      );
    }
  },
  carrier: function() {
    return /* @__PURE__ */ React.createElement("div", { className: "indexer-header__customer_carrier-area--row" }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
      CarrierName,
      {
        carrierID: this.props.email.carrier_id,
        multiple: this.props.email.single_carrier === false,
        displayAccountExec: isFactorAccount(),
        displayNoBuy: isFactorAccount(),
        carrierNameSuffix: this.setCarrierLink(),
        carrierNamePrefix: carrierNamePrefix(),
        v3ReskinEnabled: this.props.v3ReskinEnabled
      }
    )), maybeStatePill(this.props.invoice && this.props.invoice.status));
  },
  renderCustomerNames: function() {
    const customers = this.customerLines();
    if (customers.length < 3) {
      return customers.map((customer) => /* @__PURE__ */ React.createElement(
        "div",
        {
          key: customer.name,
          className: "indexer-header__customer_carrier-area--row"
        },
        /* @__PURE__ */ React.createElement("div", null, "Customer: ", customer.name),
        maybeStatePill(customer.customer_display_status)
      ));
    } else {
      const lines = customers.map((customer) => {
        const statusDisplay = showCustomerStatuses() ? "	" + (customer.customer_display_status || "<no status>") : "";
        return `${customer.name}${statusDisplay}`;
      }).join("\n");
      const namesStr = `Customer Names:

${lines}`;
      return /* @__PURE__ */ React.createElement(
        "div",
        {
          title: namesStr,
          className: "indexer-header__customer_carrier-area--row"
        },
        /* @__PURE__ */ React.createElement("div", null, "Multiple Customers"),
        showCustomerStatuses() && maybeStatePill(
          this.props.invoice && this.props.invoice.billing_display_status
        )
      );
    }
  },
  renderCustomerNamesV3Reskin: function() {
    const customers = this.customerLines();
    if (customers.length < 3) {
      return customers.map((customer, i) => /* @__PURE__ */ React.createElement("span", { key: customer.name }, /* @__PURE__ */ React.createElement("span", null, customer.name), maybeStatePillV3Reskin(customer.customer_display_status), i == 0 && customers.length > 1 ? ", " : ""));
    } else {
      const tooltipContent = customers.map((customer) => {
        const statusDisplay = showCustomerStatuses() ? " : " + (customer.customer_display_status || "<no status>") : "";
        return /* @__PURE__ */ React.createElement(
          "div",
          {
            style: { whiteSpace: "nowrap" },
            key: customer.name
          },
          `${customer.name}${statusDisplay}`
        );
      });
      return /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: "var(--space-xxxs)" } }, /* @__PURE__ */ React.createElement(
        Tooltip,
        {
          content: /* @__PURE__ */ React.createElement(
            "div",
            {
              style: {
                textDecoration: "underline",
                textDecorationStyle: "dotted"
              }
            },
            "Multiple"
          ),
          tooltipContent,
          direction: TooltipDirection.Right,
          location: TooltipLocation.Hidden
        }
      ), showCustomerStatuses() && maybeStatePillV3Reskin(
        this.props.invoice && this.props.invoice.billing_display_status
      ));
    }
  },
  customerLines: function() {
    const auditBillingEnabled = Account.auditBillingEnabled();
    const load = this.props.load;
    const loadShipments = load && load.tms_load_shipments || [];
    const customers = {};
    let order = 0;
    if (load && load.customer && load.customer.name) {
      const ls = showCustomerStatuses() && loadShipments.find((x) => x.customer_name === load.customer.name);
      customers[load.customer.name] = {
        name: load.customer.name,
        // there is an assumption that a load shipment will exist for the same customer as the load.
        // If one doesn't, we simply will not display a status since it is technically possible to not exist despite the assumption.
        customer_display_status: ls && ls.customer_display_status,
        order: order++
      };
    } else if (load && !load.customer && auditBillingEnabled) {
      customers[uuid()] = {
        // uuid is used here to ensure that each Missing Customer is treated as unique, since shipments missing customers may be for different customers and thus have distinct statuses.
        name: "(Missing Customer)",
        customer_display_status: null,
        order: order++
      };
    }
    loadShipments.forEach((ls) => {
      if (ls.customer_name && !customers[ls.customer_name]) {
        customers[ls.customer_name] = {
          name: ls.customer_name,
          customer_display_status: showCustomerStatuses() && ls.customer_display_status,
          order: order++
        };
      } else if (!ls.customer_name && auditBillingEnabled) {
        customers[uuid()] = {
          // uuid is used here to ensure that each Missing Customer is treated as unique, since shipments missing customers may be for different customers and thus have distinct statuses.
          name: "(Missing Customer)",
          customer_display_status: showCustomerStatuses() && ls.customer_display_status,
          order: order++
        };
      }
    });
    return _.sortBy(Object.values(customers), (x) => x.order);
  },
  renderDateTime: function() {
    const email = this.props.email || {};
    return /* @__PURE__ */ React.createElement("div", { className: "indexer-header__date-time" }, /* @__PURE__ */ React.createElement("span", { className: "indexer-header__date" }, generalFormatter.shortDate(email.created_at)), /* @__PURE__ */ React.createElement("span", { className: "indexer-header__time" }, " ", generalFormatter.shortTime(email.created_at)));
  },
  displayCustomerMargin: function() {
    return Account.currentSettings().display_customer_margin_in_header && this.props.invoice;
  }
});
